<script lang="ts" setup>
import { MediaImageFragment } from '~/api/graphql/generated'

export interface Teaser {
  variant: string
  type: string
  image: MediaImageFragment | undefined
  title: string
  description: string
  date: string
  link: {
    url: string
    target: string
    text: string
  }
}

const props = defineProps<{
  teaser: Teaser
}>()
</script>

<template>
  <component :is="teaser.variant === 'style_2' ? 'CardText' : 'CardImage'" v-bind="teaser" />
</template>

<style lang="scss" scoped>
.card.card-image {
  @include breakpoint(t) {
    grid-template-columns: 24px auto 54px 44px;
    :deep(.image) {
      grid-column: 2 / -1;
    }
    :deep(.sliding-content) {
      grid-column: 1 / -2;
    }
  }
  @include breakpoint(tl) {
    grid-template-columns: 48px auto 54px 57px;
  }
}
</style>
